// extracted by mini-css-extract-plugin
module.exports = {"root":"price-title_root__RKajs","sizelg":"price-title_sizelg__tgitC"};